const racism = `Rasismi on sitä, että ihmisiä kohdellaan huonosti heidän ihonvärinsä, kulttuurinsa tai lähtökohtansa vuoksi.
Jotkut suomalaiset saattavat kohdata rasismia, ja siitä on tärkeää puhua.
Monet suomalaiset ovat ystävällisiä ja kohtelevat kaikkia tasapuolisesti, olivatpa he kotoisin.
He ymmärtävät, että jokainen on erilainen ja se on ok.
He uskovat olevansa oikeudenmukaisia ja antamaan kaikille mahdollisuuden näyttää keitä he ovat.
Suomessa on myös ihmisiä, jotka saattavat ajatella, että muista maista tulevat ihmiset ottavat työnsä ja vähentävät heidän mahdollisuuksiaan.
Taantuma ja työttömyys ja alkoholismi voivat johtaa vahingollisiin ajatuksiin.
Jotkut ihmiset käyttäytyvät epäreilusti ihmisiä kohtaan, jotka eivät ole suomalaista alkuperää.
Tämä ei ole hyvästä ja voi saada heidät tuntemaan olonsa surullisiksi ja loukkaantuneiksi.
Rasismi voi vaikeuttaa ihmisten löytää työtä tai saada ystäviä, ja tämä ei ole reilua.
Eri ihmisillä on erilaisia kokemuksia rasismista.
Heitä on saatettu kohdella huonosti tai kuulla ilkeitä asioita heidän luonteensa vuoksi.
Tämä voi olla vaikeaa ja saada heidät tuntemaan itsensä yksinäiseksi.
On tärkeää, että kaikki tukevat toisiaan ja vastustavat rasismia.
On myös ihmisiä, jotka eivät koskaan koe rasismia ollenkaan.
Emme voi yleistää tätä ja sanoa, että Suomessa ei ole rasismia.
Tulevaisuudessa on tärkeää puhua edelleen rasismista ja siitä, kuinka voimme kaikki olla ystävällisiä toisillemme.
Voimme oppia toisiltamme ja ymmärtää, että jokainen on erityinen riippumatta siitä, mistä he tulevat tai miltä he näyttävät.
On tärkeää kohdella kaikkia kunnioittavasti ja ystävällisesti.`;

export default racism;